// THE ONE PLACE A SCANNED VALUE IS TURNED INTO THE VALUE A SCREEN WANTS.
// Every box that a scan can land in — camera decode, scan gun (keyboard wedge), or a
// paste — runs through here. Nothing else is allowed to parse a scan.
//
// Two robustness fixes for hardware/QR quirks, NEITHER of which changes the token itself
// (backend token matching stays case-SENSITIVE, so the capture keeps its original case):
//   1. Strip a leading AIM symbology identifier (]Q1, ]C1, ]E0, ]d1, ]q1 …): "]" + one
//      letter + one alphanumeric modifier that some scanners prepend.
//   2. Isolate the token from a scanned QR URL. The KIND segment is matched loosely
//      (`/scan/<anything>/<token>`) rather than against a hard-coded part|loc|donor list,
//      so a new label kind can never silently drop a whole URL into an input again —
//      which is exactly what a scan gun does: it TYPES the URL into whatever box has
//      focus. Matched case-insensitively on the path only.
const AIM_PREFIX = /^\][A-Za-z][A-Za-z0-9]/;
const SCAN_PATH = /\/scan\/[A-Za-z0-9_-]+\/([^/?#\s]+)/i;

export function normalizeScan(text) {
  let v = (text || "").trim();
  if (AIM_PREFIX.test(v)) v = v.slice(3).trim();
  const m = v.match(SCAN_PATH);
  return m ? m[1] : v;
}

// Did this value arrive as a QR URL (so what we hold now is an opaque token, not a
// human code)? Callers use it to STOP uppercasing — a token is case-sensitive and
// `.toUpperCase()` on one turns a valid scan into "not in the system".
export function wasScannedUrl(text) {
  return normalizeScan(text) !== (text || "").trim();
}

// IS THIS SCAN A LOT OR ITS CRATE, rather than a part tag? Used by the floor Tag Parts
// screen so one box can do both jobs: a crate/lot label SWITCHES lot, anything else is
// tagged into the lot you are working. Only the shapes this app itself prints are claimed
// here — a lot number (LOT-00123) and a lot-crate code (also LOT-prefixed, from
// `_gen_container_code("LOT", …)`). Anything ambiguous returns false and is treated as a
// tag, because tagging is the common case and a wrong guess there is caught by the server.
const LOT_CODE = /^LOT-[A-Za-z0-9-]+$/i;

export function looksLikeLotOrCrate(text) {
  const v = normalizeScan(text);
  return LOT_CODE.test(v);
}

